import { render, staticRenderFns } from "./CourseMenu.vue?vue&type=template&id=86f57cd8"
import script from "./CourseMenu.vue?vue&type=script&lang=js"
export * from "./CourseMenu.vue?vue&type=script&lang=js"
import style0 from "./CourseMenu.vue?vue&type=style&index=0&id=86f57cd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports